import apiCall from 'apps/robo-advisory/apiCalls/surveyReport';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';

export const SurveyReportListPage = () => (
  <ListPage
    title="Survey Reports"
    description="Health check result pages exist only for Health Check (FHC) reports."
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={() => (
      <DynamicFilterForm
        fields={filterConfig}
        searchFieldConfig={{ placeholder: 'Email, name, company, phone' }}
      />
    )}
  />
);

export const SurveyReportDetailPage = () => (
  <DetailPage
    title="Survey Report"
    apiCall={apiCall}
    listUrl="/robo-advisory/survey-reports"
    ItemDetail={ItemDetail}
  />
);
